import React from 'react';
import { StyledFlightList } from '../FlightList';
import { FlightListRowShimmer } from './FlightListRowShimmer';
import { FlightListHeaderShimmer } from './FlightListHeaderShimmer';
import { NavigationPlaceholder } from './NavigationPlaceholder';

interface IShimmerFlightListProps {
	listLength: number;
}

export function FlightListShimmer({ listLength }: IShimmerFlightListProps) {
	const items = new Array(listLength).fill('');

	return (
		<>
			<NavigationPlaceholder />
			<StyledFlightList>
				<FlightListHeaderShimmer />
				{items.map((_, i) => (
					// eslint-disable-next-line react/no-array-index-key
					<FlightListRowShimmer key={`shimmer-${i}`} />
				))}
			</StyledFlightList>
			<NavigationPlaceholder />
		</>
	);
}
